module.exports = __webpack_public_path__ + "static/media/pasta_70_gr.65398fdd.jpg";